import { createEtDom, mountedToDom } from "utils";
import { getIsMobile } from "utils/device";

/** 挂载到header */
const mountedToHeader = async (): Promise<void> => {
  mountedToDom(["HeaderActionBarBefore"], () => {
    return createEtDom('div', false)
  });
};

/** 移动端挂载到页头菜单之前 */
const mountedToHeaderMenuBefore = (): void => {
  mountedToDom(["HeaderMenuBefore"], () => {
    return createEtDom('div', true)
  });
};

const translateShowtime = function () {
  const isOrderPage = new RegExp(/\/order?-\w+|orders\/\d+/).test(
    location.pathname
  );

  const mobileWidth = 767; // 移动端屏幕宽度临界值
  const isMobile = getIsMobile(mobileWidth);

  // 订单页
  if (isOrderPage) {
    // 仅实例，不挂载
    createEtDom('div', isMobile);

    return;
  }

  if (isMobile) {
    mountedToHeaderMenuBefore();
  } else {
    mountedToHeader();
  }
};

export { translateShowtime };
